import { Box, Center, Heading, InputGroup, Stack } from '@chakra-ui/react';
import InputField from '../InputField';
import { FormStep } from '../MultiStepForm';

export default function Website(props: { onSubmit: any; formError: any; hasSkipButton: boolean; skipbuttonText: string; }) {
    const { onSubmit, formError } = props;
    return (
        <FormStep
            stepName="website"
            onSubmit={onSubmit}
            formError={formError}
        >
            <Center>
                <Box w="788px" h="6rem">
                    <Stack>
                        <Heading
                            fontSize="32px"
                            fontWeight={800}
                            width="800px"
                            display="flex"
                            justifyContent="center"
                            mb="12px"
                        >
                            Do you have a portfolio or website?
                        </Heading>
                        <InputGroup h="48px" gap="12px">
                            <InputField
                                name="website"
                                placeholder="https://"
                                width="788px"
                            ></InputField>
                        </InputGroup>
                    </Stack>
                </Box>
            </Center>
        </FormStep>
    );
}
